import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-1fcc432c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "comandas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "comandas-content" };
const _hoisted_4 = { class: "page-header mb-4" };
const _hoisted_5 = { class: "header-left" };
const _hoisted_6 = { class: "header-icon" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "page-title" }, "Bandeja de Almacén"),
    /*#__PURE__*/ _createElementVNode("p", { class: "page-subtitle" }, "Gestión de despachos y reingresos físicos")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "mode-toggle-group" };
const _hoisted_9 = {
    key: 0,
    class: "badge-count"
};
const _hoisted_10 = {
    key: 0,
    class: "view-section"
};
const _hoisted_11 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }, null, -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando despachos...", -1 /* HOISTED */));
const _hoisted_14 = [
    _hoisted_12,
    _hoisted_13
];
const _hoisted_15 = {
    key: 1,
    class: "empty-state bg-card"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", null, "Sin Comandas Pendientes", -1 /* HOISTED */));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "No hay nuevos tickets por despachar o imprimir.", -1 /* HOISTED */));
const _hoisted_18 = {
    key: 2,
    class: "cards-grid"
};
const _hoisted_19 = { class: "ticket-header" };
const _hoisted_20 = { class: "sucursal-badge" };
const _hoisted_21 = { class: "time-meta" };
const _hoisted_22 = { class: "ticket-body" };
const _hoisted_23 = { class: "order-info" };
const _hoisted_24 = { class: "order-title" };
const _hoisted_25 = { class: "order-code" };
const _hoisted_26 = {
    key: 0,
    class: "status-warning pulse"
};
const _hoisted_27 = { class: "client-name" };
const _hoisted_28 = { class: "items-list" };
const _hoisted_29 = { class: "item-name" };
const _hoisted_30 = { class: "scan-status" };
const _hoisted_31 = {
    key: 1,
    class: "scan-placeholder"
};
const _hoisted_32 = { class: "item-info" };
const _hoisted_33 = { class: "barcode-text" };
const _hoisted_34 = { class: "product-label" };
const _hoisted_35 = { class: "item-actions" };
const _hoisted_36 = { class: "item-qty" };
const _hoisted_37 = ["onClick"];
const _hoisted_38 = { class: "ticket-footer" };
const _hoisted_39 = { class: "footer-top w-100 flex gap-2 mb-2" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { class: "footer-actions w-100 flex gap-2" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick", "disabled"];
const _hoisted_45 = { key: 0 };
const _hoisted_46 = { key: 1 };
const _hoisted_47 = { key: 2 };
const _hoisted_48 = { key: 3 };
const _hoisted_49 = {
    key: 0,
    class: "view-section"
};
const _hoisted_50 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }, null, -1 /* HOISTED */));
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando reingresos pendientes...", -1 /* HOISTED */));
const _hoisted_53 = [
    _hoisted_51,
    _hoisted_52
];
const _hoisted_54 = {
    key: 1,
    class: "empty-state dashed-box"
};
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", null, "Sin Reingresos Pendientes", -1 /* HOISTED */));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "No hay repuestos que necesiten ser devueltos al almacén desde caja.", -1 /* HOISTED */));
const _hoisted_57 = {
    key: 2,
    class: "cards-grid"
};
const _hoisted_58 = { class: "reingreso-header" };
const _hoisted_59 = { class: "nc-code" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "status-warning" }, "REINGRESO", -1 /* HOISTED */));
const _hoisted_61 = { class: "reingreso-body" };
const _hoisted_62 = { class: "motivo-box" };
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "motivo-label" }, "MOTIVO:", -1 /* HOISTED */));
const _hoisted_64 = { class: "motivo-text" };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h6", { class: "section-subtitle" }, "Artículos a Recibir:", -1 /* HOISTED */));
const _hoisted_66 = { class: "reingreso-items" };
const _hoisted_67 = { class: "r-item-name" };
const _hoisted_68 = { class: "r-item-qty" };
const _hoisted_69 = { class: "reingreso-footer" };
const _hoisted_70 = ["onClick"];
const _hoisted_71 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_72 = { class: "scan-modal" };
const _hoisted_73 = { class: "scan-modal-header" };
const _hoisted_74 = { class: "header-info" };
const _hoisted_75 = { class: "scan-modal-content" };
const _hoisted_76 = { class: "scan-progress" };
const _hoisted_77 = { class: "progress-info" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Progreso de Verificación", -1 /* HOISTED */));
const _hoisted_79 = { class: "progress-bar" };
const _hoisted_80 = { class: "scan-items-list" };
const _hoisted_81 = { class: "scan-item-left" };
const _hoisted_82 = { class: "scan-indicator" };
const _hoisted_83 = { class: "scan-item-details" };
const _hoisted_84 = { class: "scan-item-name" };
const _hoisted_85 = { class: "scan-item-code" };
const _hoisted_86 = { class: "scan-item-right" };
const _hoisted_87 = { class: "scan-qty" };
const _hoisted_88 = { class: "scan-modal-footer" };
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "scan-hint" }, "Apunte la pistola y dispare al código del producto", -1 /* HOISTED */));
const _hoisted_90 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_PackageIcon = _resolveComponent("PackageIcon");
    const _component_ShoppingCartIcon = _resolveComponent("ShoppingCartIcon");
    const _component_RefreshCwIcon = _resolveComponent("RefreshCwIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_HomeIcon = _resolveComponent("HomeIcon");
    const _component_ClockIcon = _resolveComponent("ClockIcon");
    const _component_UserIcon = _resolveComponent("UserIcon");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ScanIcon = _resolveComponent("ScanIcon");
    const _component_PrinterIcon = _resolveComponent("PrinterIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_LockIcon = _resolveComponent("LockIcon");
    const _component_UndoIcon = _resolveComponent("UndoIcon");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Header),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Sidebar),
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode(" ── Page Header ── "),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_PackageIcon, { size: 24 })
                            ]),
                            _hoisted_7
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["btn-toggle", { 'active': _ctx.view === 'despachos' }]),
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.view = 'despachos'))
                            }, [
                                _createVNode(_component_ShoppingCartIcon, { size: 16 }),
                                _createTextVNode(" Despachos ")
                            ], 2 /* CLASS */),
                            _createElementVNode("button", {
                                class: _normalizeClass(["btn-toggle", { 'active': _ctx.view === 'reingresos' }]),
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.view = 'reingresos'))
                            }, [
                                _createVNode(_component_RefreshCwIcon, { size: 16 }),
                                _createTextVNode(" Reingresos "),
                                (_ctx.reingresos.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.reingresos.length), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */)
                        ])
                    ]),
                    _createCommentVNode(" ── VISTA DE DESPACHOS ── "),
                    (_ctx.view === 'despachos')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                                : (_ctx.ordenes.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_CheckCircleIcon, {
                                            size: 48,
                                            class: "text-success mb-3"
                                        }),
                                        _hoisted_16,
                                        _hoisted_17
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordenes, (orden) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "ticket-card",
                                                key: orden.ordenVentaId
                                            }, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createVNode(_component_HomeIcon, { size: 14 }),
                                                        _createTextVNode(" " + _toDisplayString(orden.nombreSucursal || 'Almacén Principal'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createVNode(_component_ClockIcon, { size: 14 }),
                                                        _createTextVNode(" " + _toDisplayString(new Date(orden.fechaCreacion).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("div", _hoisted_24, [
                                                            _createElementVNode("h4", _hoisted_25, _toDisplayString(orden.codigoOrden), 1 /* TEXT */),
                                                            (orden.estado === 'PendienteReingreso')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Bloqueado por Reingreso"))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _createElementVNode("p", _hoisted_27, [
                                                            _createVNode(_component_UserIcon, { size: 14 }),
                                                            _createTextVNode(" " + _toDisplayString(orden.nombreCliente), 1 /* TEXT */)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_28, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orden.detalles, (d) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                class: _normalizeClass(["item-row", { 'item-scanned': _ctx.itemConfirmado(orden.ordenVentaId, d.productoId) }]),
                                                                key: d.detalleOrdenVentaId
                                                            }, [
                                                                _createElementVNode("div", _hoisted_29, [
                                                                    _createElementVNode("div", _hoisted_30, [
                                                                        (_ctx.itemConfirmado(orden.ordenVentaId, d.productoId))
                                                                            ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                                                                key: 0,
                                                                                size: 16,
                                                                                class: "text-success"
                                                                            }))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_31))
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_32, [
                                                                        _createElementVNode("span", _hoisted_33, _toDisplayString(d.codigoBarra), 1 /* TEXT */),
                                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(d.nombreProducto), 1 /* TEXT */)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_35, [
                                                                    _createElementVNode("strong", _hoisted_36, "x" + _toDisplayString(d.cantidad), 1 /* TEXT */),
                                                                    (!_ctx.itemConfirmado(orden.ordenVentaId, d.productoId))
                                                                        ? (_openBlock(), _createElementBlock("button", {
                                                                            key: 0,
                                                                            class: "btn-manual-confirm",
                                                                            onClick: ($event) => (_ctx.confirmarItemManual(orden.ordenVentaId, d.productoId)),
                                                                            title: "Confirmar manual"
                                                                        }, [
                                                                            _createVNode(_component_CheckIcon, { size: 14 })
                                                                        ], 8 /* PROPS */, _hoisted_37))
                                                                        : _createCommentVNode("v-if", true)
                                                                ])
                                                            ], 2 /* CLASS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createElementVNode("div", _hoisted_39, [
                                                        (orden.estado !== 'Despachada')
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "btn-scan-trigger flex-1",
                                                                onClick: ($event) => (_ctx.openScanner(orden))
                                                            }, [
                                                                _createVNode(_component_ScanIcon, { size: 16 }),
                                                                _createTextVNode(" Escanear Pedido ")
                                                            ], 8 /* PROPS */, _hoisted_40))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("button", {
                                                            class: "btn-icon outline",
                                                            onClick: ($event) => (_ctx.imprimirTicket(orden)),
                                                            title: "Imprimir Comanda"
                                                        }, [
                                                            _createVNode(_component_PrinterIcon, { size: 16 })
                                                        ], 8 /* PROPS */, _hoisted_41)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_42, [
                                                        (orden.estado !== 'Despachada')
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "btn-icon danger",
                                                                onClick: ($event) => (_ctx.anularOrden(orden)),
                                                                title: "Anular Orden"
                                                            }, [
                                                                _createVNode(_component_TrashIcon, { size: 16 })
                                                            ], 8 /* PROPS */, _hoisted_43))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("button", {
                                                            class: _normalizeClass(["btn-action flex-1", orden.estado === 'Despachada' ? 'success' : 'primary']),
                                                            onClick: ($event) => (_ctx.despachar(orden)),
                                                            disabled: orden.estado === 'Despachada' || orden.estado === 'PendienteReingreso' || !_ctx.ordenLista(orden)
                                                        }, [
                                                            (orden.estado === 'Despachada')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                                                    _createVNode(_component_CheckIcon, { size: 14 }),
                                                                    _createTextVNode(" Entregado OK ")
                                                                ]))
                                                                : (orden.estado === 'PendienteReingreso')
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                                                        _createVNode(_component_LockIcon, { size: 14 }),
                                                                        _createTextVNode(" En corrección... ")
                                                                    ]))
                                                                    : (!_ctx.ordenLista(orden))
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                                                            _createVNode(_component_PackageIcon, { size: 14 }),
                                                                            _createTextVNode(" Esperando Validación ")
                                                                        ]))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_48, "Confirmar Despacho"))
                                                        ], 10 /* CLASS, PROPS */, _hoisted_44)
                                                    ])
                                                ])
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ── VISTA DE REINGRESOS ── "),
                (_ctx.view === 'reingresos')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_53))
                            : (_ctx.reingresos.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createVNode(_component_CheckCircleIcon, {
                                        size: 48,
                                        class: "text-success mb-3"
                                    }),
                                    _hoisted_55,
                                    _hoisted_56
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reingresos, (nc) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "reingreso-card",
                                            key: nc.notaCreditoId
                                        }, [
                                            _createElementVNode("div", _hoisted_58, [
                                                _createElementVNode("h5", _hoisted_59, [
                                                    _createVNode(_component_UndoIcon, { size: 16 }),
                                                    _createTextVNode(" " + _toDisplayString(nc.codigoNota), 1 /* TEXT */)
                                                ]),
                                                _hoisted_60
                                            ]),
                                            _createElementVNode("div", _hoisted_61, [
                                                _createElementVNode("div", _hoisted_62, [
                                                    _hoisted_63,
                                                    _createElementVNode("p", _hoisted_64, _toDisplayString(nc.motivo), 1 /* TEXT */)
                                                ]),
                                                _hoisted_65,
                                                _createElementVNode("div", _hoisted_66, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nc.detalles, (d) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: d.detalleNotaCreditoId,
                                                            class: "r-item-row"
                                                        }, [
                                                            _createElementVNode("div", _hoisted_67, [
                                                                _createVNode(_component_PackageIcon, {
                                                                    size: 14,
                                                                    class: "text-warning"
                                                                }),
                                                                _createElementVNode("span", null, _toDisplayString(d.nombreProducto), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("strong", _hoisted_68, "x" + _toDisplayString(d.cantidad), 1 /* TEXT */)
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_69, [
                                                _createElementVNode("button", {
                                                    class: "btn-action warning-solid w-100",
                                                    onClick: ($event) => (_ctx.confirmarRecibo(nc))
                                                }, [
                                                    _createVNode(_component_CheckCircleIcon, { size: 18 }),
                                                    _createTextVNode(" Confirmar Recibo Físico ")
                                                ], 8 /* PROPS */, _hoisted_70)
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _createCommentVNode(" ── MODAL DE ESCANEO (MODO PISTOLA) ── "),
        (_ctx.scanningOrder)
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("h3", null, "Validando Orden: " + _toDisplayString(_ctx.scanningOrder.codigoOrden), 1 /* TEXT */),
                            _createElementVNode("p", null, _toDisplayString(_ctx.scanningOrder.nombreCliente), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                            class: "btn-close",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.closeScanner && _ctx.closeScanner(...args)))
                        }, "×")
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                        _createCommentVNode(" Input oculto pero enfocado para la pistola "),
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            ref: "scannerInput",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.barcodeManual) = $event)),
                            onKeydown: _cache[4] || (_cache[4] = _withKeys(
                            //@ts-ignore
                            (...args) => (_ctx.handleScanInModal && _ctx.handleScanInModal(...args)), ["enter"])),
                            class: "hidden-input",
                            autofocus: "",
                            placeholder: "Esperando escaneo..."
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, _ctx.barcodeManual]
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("span", null, _toDisplayString(_ctx.countsConfirmados(_ctx.scanningOrder)) + " / " + _toDisplayString(_ctx.scanningOrder.detalles.length) + " ítems", 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("div", {
                                    class: "progress-fill",
                                    style: _normalizeStyle({ width: (_ctx.countsConfirmados(_ctx.scanningOrder) / _ctx.scanningOrder.detalles.length * 100) + '%' })
                                }, null, 4 /* STYLE */)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scanningOrder.detalles, (d) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: d.detalleOrdenVentaId,
                                    class: _normalizeClass(["scan-item-row", { 'scanned': _ctx.itemConfirmado(_ctx.scanningOrder.ordenVentaId, d.productoId) }])
                                }, [
                                    _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, [
                                            (_ctx.itemConfirmado(_ctx.scanningOrder.ordenVentaId, d.productoId))
                                                ? (_openBlock(), _createBlock(_component_CheckIcon, {
                                                    key: 0,
                                                    size: 14
                                                }))
                                                : (_openBlock(), _createBlock(_component_PackageIcon, {
                                                    key: 1,
                                                    size: 14
                                                }))
                                        ]),
                                        _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("span", _hoisted_84, _toDisplayString(d.nombreProducto), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_85, _toDisplayString(d.codigoBarra), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("span", _hoisted_87, "x" + _toDisplayString(d.cantidad), 1 /* TEXT */)
                                    ])
                                ], 2 /* CLASS */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createElementVNode("button", {
                            class: "btn-action primary",
                            onClick: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.closeScanner && _ctx.closeScanner(...args))),
                            disabled: !_ctx.ordenLista(_ctx.scanningOrder)
                        }, " Finalizar Verificación ", 8 /* PROPS */, _hoisted_90)
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 64 /* STABLE_FRAGMENT */));
}
